// extracted by mini-css-extract-plugin
export var dividerContainer = "_62-0";
export var line = "_62-1";